import { Gift, Link2, Lock, ShieldCheck } from "lucide-react";
import { PotAnimation } from "@/components/soon/PotAnimation";
import { SoonPage } from "@/components/soon/SoonPage";

const FEATURES = [
  [Gift, "Un pot commun privé", "Pour un anniversaire, un cadeau de départ, un week-end ou un projet de vie, en quelques secondes."],
  [Link2, "Invitez par lien", "Partagez un lien privé par WhatsApp, SMS ou email. Vos proches participent sans créer de compte."],
  [ShieldCheck, "Paiement par carte sécurisé", "Paiement par carte avec authentification 3D Secure. L'argent reste sur la cagnotte jusqu'à sa clôture."],
  [Lock, "1 € de frais par cagnotte", "Pas de pourcentage sur les participations : 1 € de frais de service CASHMY par cagnotte, c'est tout."],
];

export const PotsSoon = () => (
  <SoonPage testid="pots-soon" eyebrow="Cagnottes entre proches" title="Le pot commun, sans prise de tête"
    text="Créez une cagnotte privée, invitez vos proches par lien et collectez les participations par carte. Vous recevez l'argent sur votre compte à la clôture."
    visual={<PotAnimation />} features={FEATURES} interest="cagnotte" other={["/compte-en-ligne", "Découvrir aussi le compte en ligne + carte"]} />
);
